var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 0C62.5892 0 80.5 17.9077 80.5 40C80.5 62.0923 62.5892 80 40.5 80C18.4077 80 0.5 62.0923 0.5 40C0.5 17.9077 18.4077 0 40.5 0Z",
    fill: "#F84242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 26.5C53.9 25.9 53.1 25.9 52.5 26.5L40.5 38.5L28.5 26.5C27.9 25.9 27.1 25.9 26.5 26.5C25.9 27.1 25.9 27.9 26.5 28.5L38.5 40.5L26.5 52.5C25.9 53.1 25.9 53.9 26.5 54.5C27.1 55.1 27.9 55.1 28.5 54.5L40.5 42.5L52.5 54.5C53.1 55.1 53.9 55.1 54.5 54.5C55.1 53.9 55.1 53.1 54.5 52.5L42.5 40.5L54.5 28.5C55.1 27.9 55.1 27.1 54.5 26.5Z",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFail);
export default __webpack_public_path__ + "static/media/icon-fail.c81e92a87b7ea178bec2da864cd733a2.svg";
export { ForwardRef as ReactComponent };